import SystemMailToButton from "../../buttons/SystemMailToButton";
import {kAboutContactTexts, kSystemTexts} from "../../../constants/texts";
import {aboutScreenHighlightWords} from "../../../helpers/StringHelper";

export default function AboutContactText() {
    // Used in AboutMobileContactSection to display contact text

    // BUILD
    return (
        <div className={"text-[18px] text-greyLight9 font-medium"}>
            <span className={""}>
                {aboutScreenHighlightWords(kAboutContactTexts.message, ['questions légales'])}
            </span>
            <SystemMailToButton label={kSystemTexts.contactMailAddress}
                                mailTo={`mailto:${kSystemTexts.contactMailAddress}`} />
        </div>
    );
}